<p-dialog
  [(visible)]="open"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [style]="{ width: '60vw', minHeight: '80vh' }"
>
  <ng-template pTemplate="header">
    <h2>{{ activity.title }}</h2>
    <span>{{ activity.description }}</span>
  </ng-template>

  <ng-template pTemplate="content">
    @if (isLoading) {
      <p-skeleton width="100%" height="140px"></p-skeleton>
    } @else {
      <div
        [formGroup]="form"
        class="flex flex-col w-full items-start justify-center gap-4 px-4 py-6 h-full border rounded border-surface"
      >
        @if (documentUrl) {
          <a
            [href]="documentUrl"
            target="_blank"
            rel="noopener"
            class="flex w-full gap-4 flex-col"
            [attr.aria-label]="documentFileName ?? ''"
          >
            <div class="flex items-center gap-4">
              <i class="pi pi-file-pdf text-3xl text-primary bg-surface-100 rounded-md p-3"></i>
              <span class="text-primary font-semibold">
                {{ 'pre-employment-acknowledgement-dialog.view-document.label' | translate }}</span
              >
            </div>
            @if (documentFileName) {
              <div class="text-blue-600 hover:text-blue-800 truncate min-w-0 w-full">
                {{ documentFileName }}
              </div>
            }
          </a>
          <p-divider />
        }
        <div class="flex items-center">
          <p-checkbox formControlName="notesAcknowledged" [binary]="true"></p-checkbox>
          <span class="text-primary font-semibold p-5"> {{ notes }} </span>
        </div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'selfservice.dialog.cancel' | translate" (click)="onClose()"></button>
    <button
      pButton
      type="button"
      [label]="'selfservice.dialog.confirm' | translate"
      (click)="save()"
      [disabled]="form.invalid || isCompleted || isSaving || isLoading"
    ></button>
  </ng-template>
</p-dialog>
